import React from "react";
import ReactDOM from "react-dom";
import Routes from "./routes.js";
import config from "Config";
// Tether (required for Bootstrap 4.x)
import "tether";
// import 'tether/src/css/tether-theme-basic.sass'; // optional
require("font-awesome-webpack");
// Bootstrap 4.x
import "../scss/bootstrap/bootstrap";
import "../scss/style.scss";
// import "../scss/qld/style.scss";
import databaseCache from "Services/databaseCache";
// register some state update obersvers for mapping
require("Services/stateObservers");
require("Services/mapStateCalculations");
// recompute sql queries when section state changes
require("../index.html");

ReactDOM.render(<Routes />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./index.js